import { API } from '../../helpers';

export const commercialBaseV106 = '/api/billing/v8/admin/commercial';
export const unwrapCommercialV106 = (response) => {
  if (!response?.data?.success)
    throw new Error(response?.data?.message || 'Commercial request failed');
  return response.data.data;
};
export const validCommercialFactorV106 = (value) => {
  if (!/^(0|[1-9][0-9]{0,2})(\.[0-9]{1,12})?$/.test(String(value))) return false;
  const [whole, fraction = ''] = String(value).split('.');
  const positive = whole !== '0' || /[1-9]/.test(fraction);
  return positive && (Number(whole) < 100 || (whole === '100' && !/[1-9]/.test(fraction)));
};
export const commercialOptionsV106 = (items, value = 'id', text = 'name') =>
  (items || []).map((item) => ({ key: item[value], value: item[value], text: item[text] || String(item[value]) }));
export const previewCommercialV106 = async (scope_key, expected_revision, config) =>
  unwrapCommercialV106(await API.post(commercialBaseV106 + '/preview', { scope_key, expected_revision, config }));
export const commitCommercialV106 = async (preview_id) =>
  unwrapCommercialV106(await API.post(commercialBaseV106 + '/commit', { preview_id, confirm: true }));
